export default __webpack_public_path__ + "06d8fd4ec1e494b38a1d6383ced9861b.png";